<template>
  <div class="notif" v-if="display" appendTo="body" :class="notifClass">
    <div class="icon-left">
      <i :class="icon" class="fa-solid"></i>
    </div>
    <p>{{ notifMessage }}</p>
    <div class="icon-right">
      <i class="pi pi-times pointer" @click="close()"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { NotifEnum } from '@/models/components/NotifEnum';

const notifMessage = ref('');
const notifType = ref();
const display = ref(false);
let timeOutId: any;

const showAlert = (message: string, typeEnum: NotifEnum, time?: number) => {
  notifMessage.value = message;
  notifType.value = typeEnum;
  display.value = true;
  timeOutId = setTimeout(() => {
    display.value = false;
  }, time || 3000);
}

const close = () => {
  display.value = false;
  clearTimeout(timeOutId);
}

defineExpose({
  showAlert
});

const icon = computed(() => {
  return {
    'fa-check': notifType.value === NotifEnum.SUCCESS,
    'fa-triangle-exclamation': notifType.value === NotifEnum.ERROR,
    'fa-circle-info': notifType.value === NotifEnum.INFO,
    'fa-circle-exclamation': notifType.value === NotifEnum.WARNING
  };
});

const notifClass = computed(() => {
  return {
    'notif-success': notifType.value === NotifEnum.SUCCESS,
    'notif-error': notifType.value === NotifEnum.ERROR,
    'notif-info': notifType.value === NotifEnum.INFO,
    'notif-warning': notifType.value === NotifEnum.WARNING
  };
});
</script>

<style scoped>
.notif {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 15px;
  z-index: 9999 !important;
}

.icon-left {
  font-size: 2em;
}

.icon-right {
  position: absolute;
  top: 10px;
  right: 10px;
}

.notif p {
  margin-right: 30px;
  margin-left: 15px;
  font-size: 1.2em;
}

.notif-success {
  background-color: #d4edda;
  color: #155724;
}

.notif-error {
  background-color: #f8d7da;
  color: #721c24;
}

.notif-warning {
  background-color: #fff3cd;
  color: #856404;
}

.notif-info {
  background-color: #cce5ff;
  color: #004085;
}
</style>